import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutStepsSetGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CustomIconsModule } from '../../../../../../../custom/icons/custom-icons.module';
import { CustomCheckoutAuthGuard } from "../../../guards/custom-checkout-auth.guard";
import { CustomCheckoutProgressMobileBottomComponent } from './checkout-progress-mobile-bottom.component';

@NgModule({
  imports: [CommonModule, UrlModule, I18nModule, RouterModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutProgressMobileBottom: {
          component: CustomCheckoutProgressMobileBottomComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard, CheckoutStepsSetGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomCheckoutProgressMobileBottomComponent],
  exports: [CustomCheckoutProgressMobileBottomComponent]
})
export class CustomCheckoutProgressMobileBottomModule {
}
